import {getWindowData} from "components/windowWatcher/WindowWatcher";

let initialState = {
    ...getWindowData(),
    increase: true
};

function WindowReducer(state = initialState, action){
    switch (action.type) {
        case "SET_WINDOW_DATA":
            return action.payload;

        default:
            return state;
    }
}

export default WindowReducer;
